import cs from './cs.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import hu from './hu.json';
import id from './id.json';
import it from './it.json';
import ja from './ja.json';
import nl from './nl.json';
import pl from './pl.json';
import pt from './pt.json';
import ro from './ro.json';
import ru from './ru.json';
import th from './th.json';
import tr from './tr.json';
import uk from './uk.json';
import zhCN from './zh-CN.json';
import zhHK from './zh-HK.json';

const translations: Record<string, Record<string, string>> = {
  cs,
  de,
  en,
  'en-US': en,
  es,
  fr,
  hu,
  id,
  it,
  ja,
  nl,
  pl,
  pt,
  ro,
  ru,
  th,
  tr,
  uk,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
};

export default translations;
